import { gql } from 'apollo-angular';
import { attachedFileFragment } from '../upload/upload.fragments';

export const learningResourceArticleMinimal = gql`
  fragment LearningResourceArticleMinimal on LearningResourceArticle {
    id
    title
    image {
      id
      url
    }
  }
`;

// Content clashes with LearningResourceFile, which also has content, but there it's an Attached File
// then they can't be fetched in a combined query, so a separate WithContent is needed
export const learningResourceArticleWithContent = gql`
  fragment LearningResourceArticleWithContent on LearningResourceArticle {
    ...LearningResourceArticleMinimal
    contentJsonContent
    image {
      ...AttachedFile
    }
  }
  ${learningResourceArticleMinimal}
  ${attachedFileFragment}
`;
